module.exports = "\r\n\r\n.content {\r\n  direction: rtl;\r\n}\r\n\r\n.table thead tr th, .table thead tr td, .table tfoot tr td, .table tfoot tr th {\r\n  text-align: center !important\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/settings/access-key-user/access-key-user.component.css
// module id = ./src/app/components/settings/access-key-user/access-key-user.component.css
// module chunks = main